export enum Currency {
  IDR = 'IDR',
  JPY = 'JPY',
}
